import { Task } from "../models/task";
export function makeTaskController() {
    let tasks = [];
    function fetchTasks(source, db) {
        if (source === "localStorage" && localStorage) {
            let dataJSON = localStorage.getItem("tbTasks");
            if (!dataJSON) {
                dataJSON = "[]";
                localStorage.setItem("tbTasks", dataJSON);
            }
            try {
                tasks = Task.fromJSON(dataJSON);
            }
            catch (error) {
                console.error("failed to fetch tasks:", error);
            }
        }
    }
    function addTask(task) {
        tasks.push(task);
        saveTasksInLS();
    }
    function updateTask(id, data) {
        const task = getTaskByID(id);
        if (task) {
            task.name = data.name;
            task.description = data.description;
            task.deadline = data.deadline;
            task.priority = data.priority;
            task.notes = data.notes;
            task.project = data.project;
            task.completed = data.completed;
            saveTasksInLS();
        }
        else {
            console.error("Task not found");
        }
    }
    function deleteTask(id) {
        const idx = tasks.findIndex((t) => t.id === id);
        if (idx >= 0) {
            tasks.splice(idx, 1);
            saveTasksInLS();
        }
        else {
            console.error("Task not found");
        }
    }
    function toggleCompleted(id) {
        const task = getTaskByID(id);
        task.completed = !task.completed;
        saveTasksInLS();
    }
    function getTasks() {
        return tasks;
    }
    function getTasksByProject(projectId) {
        return tasks.filter((t) => t.project === projectId);
    }
    function getTaskByDeadline(deadline) {
        return tasks.filter((t) => t.deadline.toDateString() === deadline.toDateString());
    }
    function getTodaysTask() {
        return tasks.filter((t) => t.deadline.toDateString() === new Date().toDateString());
    }
    function getTaskByID(id) {
        return tasks.find((t) => t.id === id);
    }
    function saveTasksInLS() {
        try {
            localStorage.setItem("tbTasks", JSON.stringify(tasks));
        }
        catch (error) {
            console.error("failed to save tasks:", error);
        }
    }
    return {
        fetchTasks,
        addTask,
        updateTask,
        deleteTask,
        getTasks,
        getTaskByID,
        getTaskByDeadline,
        getTodaysTask,
        getTasksByProject,
        toggleCompleted,
    };
}
